<template>
  <DBox
    :id="'cmp-distribution-shop_grouops-sidewindow-shop_groups_setup'"
    :addButton="false"
  >
    <!-- :expandable="true" -->
    <TextField2
      :id="'shop_group_name'"
      :placeholder="$t('shops_group')"
      :label="$t('shops_group')"
      :value="selectedShop_groupDetails.shop_group.shop_group_name"
      @blur="onTextFieldValueChange"
      lw="150px"
    />
    <TextField2
      disabled="disabled"
      :id="'channel'"
      :label="$t('channel')"
      :placeholder="$t('channel')"
      :value="selectedShop_groupDetails.shop_group.channel"
      @blur="onTextFieldValueChange"
      lw="150px"
    />
    <!-- :disabled="true" -->

    <!-- <Dropdown2
      :id="'channel'"
      :disabled="true"
      :label="$t('channel')"
      :options="channelsTV"
      :selected="
        channelsTV.find(
          e => e.value == selectedShop_groupDetails.shop_group.channel
        )
      "
      v-on:selectedChange="e => onDropdownChange('channel', e)"
    /> -->

    <Dropdown2
      :id="'group_type'"
      :label="$t('shop_group_type')"
      :placeholder="$t('shop_group_type')"
      :options="GroupTypeTV"
      :selected="GroupTypeTV.find(e => e.value == group_type)"
      v-on:selectedChange="e => onDropdownChange('group_type', e)"
      lw="150px"
    />

    <TextField2
      :id="'shop_auto_fetch'"
      :placeholder="$t('shop_auto_fetch')"
      :label="$t('shop_auto_fetch')"
      :value="selectedShop_groupDetails.shop_group.shop_auto_fetch"
      @blur="onTextFieldValueChange"
      :bb="'none'"
      lw="150px"
    />
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import { createTV } from "../../../../models/text-value.model";

export default {
  components: {
    DBox
  },
  data: function() {
    return {
      disabled: false,
      groupType: 0
    };
  },
  props: ["selectedShop_groupDetails"],
  mounted: function() {
    // console.log(
    //   "channelsTV ",
    //   createTV(this.selectedShop_groupDetails.channels, "channel", "channel")
    // );
    console.log("GroupTypeTV ", this.GroupTypeTV);
  },
  computed: {
    GroupTypeTV: function() {
      // return [{ text: "General", value: 0 }, { text: "Special", value: 1 }];
      return [{ text: "General", value: 1 }, { text: "Special", value: 2 }];
    },

    group_type: function() {
      // console.log(
      //   "groupType ",
      //   this.selectedShop_groupDetails.shop_group.group_type
      // );
      if (
        this.selectedShop_groupDetails.shop_group.group_type > 1 ||
        this.selectedShop_groupDetails.shop_group.group_type == 0 ||
        this.selectedShop_groupDetails.shop_group.group_type == null
      ) {
        return (this.groupType = 2);
      } else if (this.selectedShop_groupDetails.shop_group.group_type == 1) {
        return (this.groupType = 1);
      } else {
        return this.selectedShop_groupDetails.shop_group.group_type;
      }
    },

    channelsTV: function() {
      return createTV(
        this.selectedShop_groupDetails.channels,
        "channel",
        "channel"
      );
    }
  },
  methods: {
    onTextFieldValueChange: function(event) {
      const { name, value } = event;
      this.$emit("changed", { name, value });
    },
    onDropdownChange: function(name, value) {
      // console.log("onDropdownChange ", name, value);

      if (value.value == 1) {
        this.$emit("changed", { name, value: 1 });
      } else {
        this.$emit("changed", { name, value: 0 });
      }
      // this.$emit("changed", { name, value: value.value });
    }
  }
};
</script>

<style lang="scss">
.cmp-distribution-shop_grouops-sidewindow-shop_groups_setup {
  --fc2-disabled-bc: hsla(0, 0%, 94%, 1);
  &:hover {
    .fc2 {
      input#channel {
        // background-color: var(--fc2-bc);
        background-color: var(--fc2-disabled-bc);
      }
    }
  }
  .fc2 {
    // --fc2-lw: 150px !important;
    label {
      &.fc2-label {
        white-space: pre-wrap !important;
        height: 48px;
      }
    }
    .fc-control {
      &#channel {
        background-color: transparent;
        &:hover,
        &:active,
        &:focus {
          background-color: var(--fc2-disabled-bc);
          border-color: var(--fc2-disabled-bc);
          margin: 3px 3px 3px 0px;
        }
      }
    }
  }
}
</style>
